import types from '../../../mutation-types';
import wootConstants from '../../../../constants/globals';
import { matchesFilters } from './filterHelpers';

export const setPageFilter = ({ dispatch, filter, page, markEndReached }) => {
  dispatch('conversationPage/setCurrentPage', { filter, page }, { root: true });
  if (markEndReached) {
    dispatch('conversationPage/setEndReached', { filter }, { root: true });
  }
};

export const setContacts = (commit, chatList) => {
  commit(
    `contacts/${types.SET_CONTACTS}`,
    chatList.map(chat => chat.meta.sender)
  );
};

export const isOnMentionsView = ({ route: { name: routeName } }) => {
  const MENTION_ROUTES = [
    'conversation_mentions',
    'conversation_through_mentions',
  ];
  return MENTION_ROUTES.includes(routeName);
};

export const isOnUnattendedView = ({ route: { name: routeName } }) => {
  const UNATTENDED_ROUTES = [
    'conversation_unattended',
    'conversation_through_unattended',
  ];
  return UNATTENDED_ROUTES.includes(routeName);
};

export const isOnFoldersView = ({ route: { name: routeName } }) => {
  const FOLDER_ROUTES = [
    'folder_conversations',
    'conversations_through_folders',
  ];
  return FOLDER_ROUTES.includes(routeName);
};

const isFolderOrderedForRecentConversations = folder => {
  return (
    !folder.sort_by ||
    folder.sort_by === wootConstants.SORT_BY_TYPE.LAST_ACTIVITY_AT_DESC ||
    folder.sort_by === wootConstants.SORT_BY_TYPE.CREATED_AT_DESC
  );
};

export const isOnFoldersMatchingView = (rootState, conversation) => {
  if (!isOnFoldersView(rootState)) return true;
  let folderId = rootState.route.params.id;
  if (!folderId) return true;
  folderId = Number(folderId);
  const folder = rootState.customViews.conversation.records.find(
    r => r.id === folderId
  );
  const currentUserId = rootState.auth?.currentUser?.id;
  return (
    folder &&
    isFolderOrderedForRecentConversations(folder) &&
    matchesFilters(conversation, folder.query.payload, { currentUserId })
  );
};

export const buildConversationList = (
  context,
  requestPayload,
  responseData,
  filterType,
  { replaceExisting = false } = {}
) => {
  const { payload: conversationList, meta: metaData } = responseData;
  if (replaceExisting) {
    context.dispatch('conversationPage/reset', null, { root: true });
    context.commit(types.REPLACE_CONVERSATION_LIST, conversationList);
  } else {
    context.commit(types.SET_ALL_CONVERSATION, conversationList);
  }
  context.dispatch('conversationStats/set', metaData);
  context.dispatch(
    'conversationLabels/setBulkConversationLabels',
    conversationList
  );
  context.commit(types.CLEAR_LIST_LOADING_STATUS);
  setContacts(context.commit, conversationList);
  setPageFilter({
    dispatch: context.dispatch,
    filter: filterType,
    page: requestPayload.page,
    markEndReached: !conversationList.length,
  });
};

const isMatchingInboxFilter = (conversation, currentInbox) => {
  return !currentInbox || Number(currentInbox) === conversation.inbox_id;
};

export const conversationMatchesCurrentView = (
  conversation,
  state,
  rootState
) => {
  const { currentInbox, appliedFilters } = state;
  const hasAppliedFilters = !!appliedFilters.length;
  return (
    !hasAppliedFilters &&
    isOnFoldersMatchingView(rootState, conversation) &&
    !isOnMentionsView(rootState) &&
    !isOnUnattendedView(rootState) &&
    isMatchingInboxFilter(conversation, currentInbox)
  );
};
